<template>
    <div class="points-ring">
        <svg class="points-ring-track" viewBox="0 0 184 184" aria-hidden="true">
            <defs>
                <filter
                    id="points-ring-inset"
                    x="-25%"
                    y="-25%"
                    width="150%"
                    height="150%"
                    color-interpolation-filters="sRGB"
                >
                    <feOffset in="SourceAlpha" dy="1.353" result="o1" />
                    <feGaussianBlur in="o1" stdDeviation="1.353" result="b1" />
                    <feComposite in="SourceAlpha" in2="b1" operator="out" result="r1" />
                    <feFlood flood-color="#000000" flood-opacity="0.04" result="c1" />
                    <feComposite in="c1" in2="r1" operator="in" result="s1" />

                    <feOffset in="SourceAlpha" dy="4.059" result="o2" />
                    <feGaussianBlur in="o2" stdDeviation="2.029" result="b2" />
                    <feComposite in="SourceAlpha" in2="b2" operator="out" result="r2" />
                    <feFlood flood-color="#000000" flood-opacity="0.03" result="c2" />
                    <feComposite in="c2" in2="r2" operator="in" result="s2" />

                    <feOffset in="SourceAlpha" dy="8.118" result="o3" />
                    <feGaussianBlur in="o3" stdDeviation="2.706" result="b3" />
                    <feComposite in="SourceAlpha" in2="b3" operator="out" result="r3" />
                    <feFlood flood-color="#000000" flood-opacity="0.02" result="c3" />
                    <feComposite in="c3" in2="r3" operator="in" result="s3" />

                    <feOffset in="SourceAlpha" dy="14.882" result="o4" />
                    <feGaussianBlur in="o4" stdDeviation="3.382" result="b4" />
                    <feComposite in="SourceAlpha" in2="b4" operator="out" result="r4" />
                    <feFlood flood-color="#000000" flood-opacity="0.01" result="c4" />
                    <feComposite in="c4" in2="r4" operator="in" result="s4" />

                    <feMerge>
                        <feMergeNode in="SourceGraphic" />
                        <feMergeNode in="s1" />
                        <feMergeNode in="s2" />
                        <feMergeNode in="s3" />
                        <feMergeNode in="s4" />
                    </feMerge>
                </filter>
            </defs>

            <circle
                class="points-ring-base"
                cx="92"
                cy="92"
                :r="radius"
                :stroke-width="band"
                filter="url(#points-ring-inset)"
            />

            <circle
                class="points-ring-progress"
                cx="92"
                cy="92"
                :r="radius"
                :stroke-width="band"
                :stroke="color"
                stroke-linecap="round"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="dashOffset"
            />
        </svg>

        <div class="points-ring-center">
            <span class="points-ring-value">{{ formattedValue }}</span>
            <span class="points-ring-label" v-lang="'dashboard-points'"></span>
        </div>
    </div>
</template>

<script>
const OUTER = 92;
const INNER = OUTER * 0.7;
const RADIUS = (OUTER + INNER) / 2;
const BAND = OUTER - INNER;

export default {
    name: "PointsRing",
    props: {
        value: {
            type: Number,
            default: 0,
        },
        progress: {
            type: Number,
            default: 0,
        },
        color: {
            type: String,
            default: "#2aaa4c",
        },
    },
    computed: {
        radius() {
            return RADIUS;
        },
        band() {
            return BAND;
        },
        circumference() {
            return 2 * Math.PI * RADIUS;
        },
        dashOffset() {
            const bounded = Math.min(Math.max(this.progress, 0), 100);

            return this.circumference * (1 - bounded / 100);
        },
        formattedValue() {
            return new Intl.NumberFormat(this.$root.lang === "en" ? "en-US" : "pt-BR").format(this.value);
        },
    },
};
</script>

<style lang="scss">
.points-ring {
  position: relative;
  width: clamp(10rem, 49vw, 11.5rem);
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  @supports not (aspect-ratio: 1) {
    height: clamp(10rem, 49vw, 11.5rem);
  }
}

.points-ring-track {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.points-ring-base {
  fill: none;
  stroke: #f3f4f6;
}

.points-ring-progress {
  fill: none;
  transition: stroke-dashoffset 0.8s ease-in-out;
}

.points-ring-center {
  position: relative;
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.points-ring-value {
  font-size: clamp(1.25rem, 6vw, 1.5rem);
  font-weight: 400;
  line-height: 1.3;
  color: #111927;
}

.points-ring-label {
  font-size: clamp(0.875rem, 4vw, 1rem);
  font-weight: 500;
  line-height: 1.2;
  color: #6c737f;
}
</style>
